import axios from 'axios'

export default {
    namespaced: true,
    state: {
        appSettings: {},
    },
    mutations: {
        SET_APPSETTINGS(state, payload) {
            state.appSettings = payload;
        },
    },
    actions: {
        FetchAuthToken({ }, obj) {
            return new Promise((resolve, reject) => {
                axios.post(`${process.env.BASE_URL}api/auth/token`, obj)
                    .then(response => {
                        if (response.data.success) {
                            sessionStorage.appToken = response.data.token;
                            resolve(response.data);
                        } else reject(response.data.message);
                    }).catch(error => { reject(`FetchAuthToken: ${error.message}`); });
            });
        },
        FetchAppSettings({ commit }) {
            return new Promise((resolve, reject) => {
                axios.get(`${process.env.BASE_URL}api/app-settings/fetch`, { headers: { Authorization: `Bearer ${sessionStorage.appToken}` } })
                    .then(response => {
                        if (response.data.success) {
                            commit('SET_APPSETTINGS', response.data.payload);
                            resolve(response.data.message);
                        } else reject(response.data.message);
                    }).catch(error => { reject(`FetchAppSettings: ${error.message}`); });
            });
        },
    },
    getters: {
        AppSettings(state) { return state.appSettings; },
    }
};
